import React from 'react';
import { Box, Pagination as MuiPagination, Typography, FormControl, Select, MenuItem, useMediaQuery, useTheme,  } from '@mui/material';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  totalCount, 
  pageSize,
  onPageChange,
  onPageSizeChange,
  showPageSize = true,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (totalPages <= 1 && !showPageSize) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 2,
        gap: 2,
      }}
    >
      {/* اطلاعات */}
      <Typography variant="body2" color="text.secondary">
        نمایش {((currentPage - 1) * pageSize) + 1} تا {Math.min(currentPage * pageSize, totalCount)} از {totalCount}
      </Typography>

      {/* صفحه‌بندی */}
      {totalPages > 1 && (
        <MuiPagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => onPageChange(page)}
          color="primary"
          size={isMobile ? 'small' : 'medium'}
          showFirstButton
          showLastButton
        />
      )}

      {/* تعداد در صفحه */}
      {showPageSize && onPageSizeChange && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            تعداد:
          </Typography>
          <FormControl size="small">
            <Select
              value={pageSize}
              onChange={(e) => onPageSizeChange(e.target.value)}
              sx={{ minWidth: 70 }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default Pagination;